<div class="cald_dialog">
  <div class="cald_header">
    <button class="close-dialog-button sap-icon" data-dismiss="modal" (click)="cancel()">&#xe03e;</button>
    <h2>{{ 'Admin.FormulaVisualizer.PageTitle' | translate }}</h2>
  </div>
  <div class="cald_content">
    <mat-card appearance="outlined">
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <mat-nested-tree-node *matTreeNodeDef="let node">
          <li>
            <div class="mat-tree-node" [innerHtml]='node.name ? node.name : node.value'></div>
          </li>
        </mat-nested-tree-node>
        <mat-nested-tree-node *matTreeNodeDef="let node; when: setNodeChildrenValueAndCheckHasChild">
          <li class="visualize-tree-container">
            <div class="mat-tree-node">
              <button mat-icon-button matTreeNodeToggle
                [matTreeNodeToggleRecursive]="false"
                [attr.aria-label]="'toggle ' + node.filename">
                <mat-icon [ngClass]="{'expand_more' : treeControl.isExpanded(node)}">
                </mat-icon>
              </button>
              <span class="color-control" [innerHtml]='node.name ? node.name : node.value'></span>
            </div>
            <ul class="visualize-tree-nested-node">
              @if (treeControl.isExpanded(node)) {
                <div>
                  <ng-container matTreeNodeOutlet></ng-container>
                </div>
              }
            </ul>
          </li>
        </mat-nested-tree-node>
      </mat-tree>
    </mat-card>
  </div>
  <div class="form-inline cald_dialog_buttonbar">
    <button type="button" class="btn btn-primary fiori3-btn-primary" (click)="cancel()">{{'Msg.Close' | translate}}</button>
  </div>
</div>
